import { render, staticRenderFns } from "./OrderMovementsDetailsHistory.vue?vue&type=template&id=5c3f109a&scoped=true"
import script from "./OrderMovementsDetailsHistory.vue?vue&type=script&lang=js"
export * from "./OrderMovementsDetailsHistory.vue?vue&type=script&lang=js"
import style0 from "./OrderMovementsDetailsHistory.vue?vue&type=style&index=0&id=5c3f109a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c3f109a",
  null
  
)

export default component.exports